<template>
    <div class="container">
        <el-row :gutter="20">
            <el-col :span="6">
                <el-row :gutter="20" class="listBorder" v-if="!banSubmit" >
                    <el-col :span="24">
                        <span class="font_1">剩余时间</span>
                        <br>
                        <span class="font_3" v-if="examRecord">{{ excessTimeText }}</span>
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="listBorder">
                    <el-col :span="24">
                        <span class="font_1">题目列表</span>
                        <br>
                        <el-row :gutter="20"  v-if="homeworkList">
                            <el-col :span="4" class="problemBorder" v-for="(homework, index) in homeworkList" :key="homework.homeworkId">
                                <el-progress type="circle" :percentage="100" :width="50" :color="(Problem && currentIndex == index) ? '#76EE00' : '#00BFFF'"  @click="choseProblem(index)" v-if="homework.problemRecord.answer == ''">
                                    <span class="percentage-value">{{ index + 1 }}</span>
                                </el-progress>
                                <el-progress type="circle" :percentage="100" :width="50" status="success"  :color="(Problem && currentIndex == index) ? '#66CD00' : '#76EE00'"  @click="choseProblem(index)" v-if="homework.problemRecord.answer != ''" />
                            </el-col>
                        </el-row>
                        <el-button type="success" icon="Select" class="btnStyle" @click="submitHomework();"  v-if="!banSubmit" plain>提交作业</el-button>
                    </el-col>
                </el-row>
            </el-col>


            <el-col :span="16" class="listBorder">
                <div v-if="Problem">
                    <span class="font_1">题目展示</span>
                    <div class="form-floating formStyle">
                        <span class="font_2">{{ currentIndex + 1 }}、题目内容（分值：{{ Problem.score }}）</span>
                        <p style="white-space: pre-line;" v-html="Problem.content"></p>
                    </div>

                    <!-- 填空题 -->
                    <div v-if="Problem.type == 1">
                        <div class="form-floating formStyle">
                            <input type="text" class="form-control" id="editFillValue" :value="Problem.problemRecord.answer" placeholder="name@example.com" @change="changeAnswer(Problem.type, currentIndex);">
                            <label for="editFillValue">填空题答案</label>
                        </div>
                    </div>

                    <!-- 单选题 -->
                    <div v-if="Problem.type == 2">
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                A、
                                <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="A" aria-label="Radio button for following text input" @change="changeAnswer(Problem.type, currentIndex);" v-bind:checked="Problem.problemRecord.answer == 'A'">
                            </div>
                            <input type="text" class="form-control" id="editSingleValueA" :value="Problem.answerA" aria-label="Text input with radio button">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                B、
                                <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="B" aria-label="Radio button for following text input" @change="changeAnswer(Problem.type, currentIndex);" v-bind:checked="Problem.problemRecord.answer == 'B'">
                            </div>
                            <input type="text" class="form-control" id="editSingleValueB" :value="Problem.answerB" aria-label="Text input with radio button">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                C、
                                <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="C" aria-label="Radio button for following text input" @change="changeAnswer(Problem.type, currentIndex);" v-bind:checked="Problem.problemRecord.answer == 'C'">
                            </div>
                            <input type="text" class="form-control" id="editSingleValueC" :value="Problem.answerC" aria-label="Text input with radio button">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                D、
                                <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="D" aria-label="Radio button for following text input" @change="changeAnswer(Problem.type, currentIndex);" v-bind:checked="Problem.problemRecord.answer == 'D'">
                            </div>
                            <input type="text" class="form-control" id="editSingleValueD" :value="Problem.answerD" aria-label="Text input with radio button">
                        </div>
                    </div>

                     <!-- 多选题 -->
                    <div v-if="Problem.type == 3">
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                A、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="A" aria-label="Checkbox for following text input" @change="changeAnswer(Problem.type, currentIndex);"  v-bind:checked="Problem.problemRecord.answer.includes('A')">
                            </div>
                            <input type="text" class="form-control" id="editMultipleValueA" :value="Problem.answerA"  aria-label="Text input with checkbox">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                B、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="B" aria-label="Checkbox for following text input" @change="changeAnswer(Problem.type, currentIndex);" v-bind:checked="Problem.problemRecord.answer.includes('B')">
                            </div>
                            <input type="text" class="form-control" id="editMultipleValueB" :value="Problem.answerB" aria-label="Text input with checkbox">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                C、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="C" aria-label="Checkbox for following text input" @change="changeAnswer(Problem.type, currentIndex);" v-bind:checked="Problem.problemRecord.answer.includes('C')">
                            </div>
                            <input type="text" class="form-control" id="editMultipleValueC" :value="Problem.answerC" aria-label="Text input with checkbox">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                D、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="D" aria-label="Checkbox for following text input" @change="changeAnswer(Problem.type, currentIndex);" v-bind:checked="Problem.problemRecord.answer.includes('D')">
                            </div>
                            <input type="text" class="form-control" id="editMultipleValueD" :value="Problem.answerD" aria-label="Text input with checkbox">
                        </div>
                    </div>

                    <!-- 判断题 -->
                    <div v-if="Problem.type == 4">
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                A、
                                <input class="form-check-input mt-0" name="editJudgeValue" type="radio" value="A" aria-label="Radio button for following text input" @change="changeAnswer(Problem.type, currentIndex);" v-bind:checked="Problem.problemRecord.answer == 'A'">
                            </div>
                            <input type="text" class="form-control" id="editJudgeValueA" :value="Problem.answerA" aria-label="Text input with radio button" >
                            <span class="displayStyle">————————</span>
                            <div class="input-group-text">
                                B、
                                <input class="form-check-input mt-0" name="editJudgeValue" type="radio" value="B" aria-label="Radio button for following text input" @change="changeAnswer(Problem.type, currentIndex);" v-bind:checked="Problem.problemRecord.answer == 'B'">
                            </div>
                            <input type="text" class="form-control" id="editJudgeValueB" :value="Problem.answerB" aria-label="Text input with radio button">
                        </div>
                    </div>

                    <!-- 简答题 -->
                    <div v-if="Problem.type == 5">
                        <div class="form-floating formStyle">
                            <textarea class="form-control" placeholder="Leave a comment here" id="editShortAnswer" :value="Problem.problemRecord.answer" @change="changeAnswer(Problem.type, currentIndex);"></textarea>
                            <label for="editShortAnswer">简答题答案</label>
                        </div>
                    </div>

                    <div class="form-floating formStyle" v-if="banSubmit">
                        <textarea class="form-control" placeholder="Leave a comment here" id="editShortAnswer" :value="Problem.rightAnswer"></textarea>
                        <label for="editShortAnswer">正确答案</label>
                    </div>

                    <div class="form-floating formStyle" v-if="banSubmit">
                        <textarea class="form-control" placeholder="Leave a comment here" id="editShortAnswer" :value="Problem.problemRecord.score"></textarea>
                        <label for="editShortAnswer">得分</label>
                    </div>

                    <el-button type="primary" icon="Edit" class="btnStyle" @click="saveProblem(Problem.type, Problem.problemRecord.recordId)" v-if="!banSubmit" plain>保存题目</el-button>
                </div>
            </el-col>
        </el-row>

                


  </div>
</template>

<script setup>

import { ref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import $ from "jquery";
import { useRoute } from "vue-router";
import router from "@/router/index";

const courseId = ref();
const examId = ref();

const Route = useRoute(); //获取到值
const Problem = ref();
const homeworkList = ref();
const currentIndex = ref(0);
const homeworkRecord = ref([]);
const banSubmit = ref(false);
const examRecord = ref();
const excessTime = ref();
const excessTimeText = ref("00:00");
const count = ref(1);

// 在组件初始化时获取路由参数并设置为 current_page
onMounted(() => {
  // 获取路由参数并设置为 current_page
  courseId.value = Route.params.courseId || '';
  examId.value = Route.params.examId || '';
  pullExamRecord();
  pullProblemList();
  
  let c = 0;
  let timer = setInterval(() => {

    if (c == 50) clearInterval(timer);
        if (banSubmit.value == false) {
            // 同步考试时间
            let timer1 = setInterval(() => {
                
                if (excessTime.value <= 0) {
                    ElMessage({
                            type: "error",
                            message: "考试已结束"
                        });
                        clearInterval(timer1);
                        const token = localStorage.getItem("token");
                        $.ajax({
                            url: "http://124.222.105.205:5000/api/exam/syncExcessTime",
                            data: {
                                examId: examId.value,
                                excessTime: excessTime.value
                            },
                            type: "post",
                            headers: {
                            Authorization: "Bearer " + token,
                            },
                            success(resp) {
                                if (resp.code != "200") {
                                    ElMessage({
                                        type: "error",
                                        message: resp.msg
                                    });
                                }       
                            },
                            error() {
                                ElMessage({
                                    type: "error",
                                    message: "同步数据失败"
                                });
                            },
                        });
                        submitExamAjax();
                        router.push({ name: "ExamOver" });
                    }
                if (excessTime.value != null && excessTime.value > 0) {
                    let hours = Math.floor(excessTime.value / 3600);
                    let minutes = Math.floor((excessTime.value % 3600) / 60);
                    let seconds = excessTime.value % 60;

                    // 将单个数字转换为两位数的格式（例如，将 1 转换为 "01"）
                    let formattedHours = ("0" + hours).slice(-2);
                    let formattedMinutes = ("0" + minutes).slice(-2);
                    let formattedSeconds = ("0" + seconds).slice(-2);

                    // 更新 hour、minute 和 second 变量
                    hours = formattedHours;
                    minutes = formattedMinutes;
                    seconds = formattedSeconds;

                    excessTimeText.value = hours + ":" + minutes + ":" + seconds;
                    excessTime.value --;

                    // 开始时同步一次数据， 每隔10s同步一次数据
                    if (count.value == 1) {
                        count.value = 0;
                        const token = localStorage.getItem("token");
                        $.ajax({
                            url: "http://124.222.105.205:5000/api/exam/syncExcessTime",
                            data: {
                                examId: examId.value,
                                excessTime: excessTime.value
                            },
                            type: "post",
                            headers: {
                            Authorization: "Bearer " + token,
                            },
                            success(resp) {
                                if (resp.code != "200") {
                                    ElMessage({
                                        type: "error",
                                        message: resp.msg
                                    });
                                }       
                            },
                            error() {
                                ElMessage({
                                    type: "error",
                                    message: "同步数据失败"
                                });
                            },
                        });
                
                
                    }
                    count.value ++ ;
                }
            }, 1000);
            clearInterval(timer);
        }
    c ++;

  }, 200);
    
  
});

// 加载题目信息
const pullProblemList = () => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/problem/getProblemRecord",
    data: {
        examId: examId.value,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
        if (resp.code == "200" || resp.code == "210") {
            homeworkList.value = resp.data;
            console.log(homeworkList.value);
            Problem.value = homeworkList.value[currentIndex.value];
            for(let record of homeworkList.value) {
                homeworkRecord.value.push(record.problemRecord);
            }
            if (resp.code == "210") banSubmit.value = true;
            
        } else {
            ElMessage({
                type: "error",
                message: "拉取题目失败！"
            });
        }
    },
    error() {
        ElMessage({
            type: "error",
            message: "拉取题目失败！"
        });
    },
  });
};

// 加载试卷记录信息
const pullExamRecord = () => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/homework/getExamRecord",
    data: {
        examId: examId.value,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
        if (resp.code == "200") {
            examRecord.value = resp.data;
            excessTime.value = examRecord.value.excessTime;
            console.log(excessTime.value);
            // if (examRecord.value != null && examRecord.value.score != null) banSubmit.value = true;
            
        } else {
            ElMessage({
                type: "error",
                message: "拉取批阅状态失败！"
            });
        }
    },
    error() {
        ElMessage({
            type: "error",
            message: "拉取批阅状态失败！"
        });
    },
  });
};


const changeAnswer = (type, index) => {
    //console.log(type + "__" + index);

    let rightAnswer = "";
    
    // 填空题
    if (type == 1) {
        rightAnswer = $("#editFillValue").val();
    }   

    // 单选题
    if (type == 2) {
        // 获取被选中的单选框的值
        var selectedValue = $('input[name="editSingleValue"]:checked').val();

        rightAnswer = selectedValue;
    }

    // 多选题
    if (type == 3) {
        
        // 获取被选中的单选框的值
        var selectedValuesString = "";

        // 遍历所有被选中的复选框并将值以逗号分割的形式添加到字符串中
        $('input[name="editMultipleValue"]:checked').each(function(index) {
            // 如果不是第一个值，则在值前加上逗号
            if (index > 0) {
                selectedValuesString += ",";
            }
            selectedValuesString += $(this).val();
        });

        rightAnswer = selectedValuesString;
    }

    // 判断题
    if (type == 4) {
        
        // 获取被选中的单选框的值
        var judgeValue = $('input[name="editJudgeValue"]:checked').val();
        rightAnswer = judgeValue;
    }

    // 简答题
    if (type == 5) {
        rightAnswer = $("#editShortAnswer").val();
    }

    homeworkRecord.value[index].answer = rightAnswer;
    // console.log(homeworkRecord.value);
}


const saveProblem = (type, id) => {
    let rightAnswer = "";
    
    // 填空题
    if (type == 1) {
        rightAnswer = $("#editFillValue").val();
    }   

    // 单选题
    if (type == 2) {
        // 获取被选中的单选框的值
        var selectedValue = $('input[name="editSingleValue"]:checked').val();

        rightAnswer = selectedValue;
    }

    // 多选题
    if (type == 3) {
        
        // 获取被选中的单选框的值
        var selectedValuesString = "";

        // 遍历所有被选中的复选框并将值以逗号分割的形式添加到字符串中
        $('input[name="editMultipleValue"]:checked').each(function(index) {
            // 如果不是第一个值，则在值前加上逗号
            if (index > 0) {
                selectedValuesString += ",";
            }
            selectedValuesString += $(this).val();
        });

        rightAnswer = selectedValuesString;
    }

    // 判断题
    if (type == 4) {
        
        // 获取被选中的单选框的值
        var judgeValue = $('input[name="editJudgeValue"]:checked').val();
        rightAnswer = judgeValue;
    }

    // 简答题
    if (type == 5) {
        rightAnswer = $("#editShortAnswer").val();
    }
    const token = localStorage.getItem("token");
    $.ajax({
    url: "http://124.222.105.205:5000/api/problem/updateProblemRecord",
    type: "post",
    data: {
        rightAnswer: rightAnswer,
        recordId: id
    },
    headers: {
        Authorization: "Bearer " + token,
    },
    success(resp) {
        if (resp.code === "200") {
            ElMessage({
                type: "success",
                message: resp.msg
            });
            setTimeout(() => {
                pullProblemList();
            }, 200);
            
            
        } else {
            ElMessage({
                type: "error",
                message: resp.msg
            });
        }
    },
    error() {
        ElMessage({
            type: "error",
            message: "保存失败！"
        });
    }
});

}

const choseProblem = (index) => {
    Problem.value = homeworkList.value[index];
    currentIndex.value = index;
}

const submitHomework = () => {

    ElMessageBox.confirm("是否提交试卷?", "提交试卷", {
        confirmButtonText: "确认提交",
        cancelButtonText: "取消",
        type: "warning",
    })
    .then(() => {
        submitExamAjax();
       
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消提交",
      });
    });

}


const submitExamAjax = () =>  {
    const token = localStorage.getItem("token");
        let examRecordList = JSON.stringify(homeworkRecord.value);
        $.ajax({
        url: "http://124.222.105.205:5000/api/problem/submitProblem",
        type: "post",
        data: examRecordList,
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code === "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg
                });
                setTimeout(() => {
                    location.reload();
                }, 200);
                
                
            } else {
                ElMessage({
                    type: "error",
                    message: resp.msg
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "提交失败！"
            });
        }
    });
}
</script>

<style scoped>
.listBorder {
    background-color: rgb(247, 246, 246);
    border-radius: 20px;
    margin: 20px;
}

.percentage-value {
  display: block;
  font-size: 20px;
  transition: 300ms;
}

.percentage-value:hover{
  display: block;
  font-size: 28px;
  transition: 500ms;
}

.problemBorder {
    margin: 10px;
}

.problemBorder:hover{
    cursor: pointer;
    width: 40px;
}

.btnStyle {
    float: right;
    margin: 5px;
}

.font_1{
    font-size: 20px;
    font-weight: bold;
    color: rgb(112, 112, 112);
}
.font_2{
    font-size: 15px;
    font-weight: bold;
    color: rgb(112, 112, 112);
}

.font_3{
    font-size: 35px;
    font-weight: bold;
    color: rgb(49, 49, 49);
}

.formStyle {
    margin: 10px;
}

.judgeStyle {
    width: 800px;
    padding: 20px;
}

.displayStyle {
    color: rgba(240, 248, 255, 0);
}

</style>